import { createFormikFields } from "@components/forms/fields/createFormikFields";
import { FC } from "react";
import { addClientInviteRoleOptions, ClientFormSchema } from "./lib";
import styles from "./InviteStep.module.scss";

const fields = createFormikFields<ClientFormSchema>();

export const InviteStep: FC = () => (
    <>
        <p>Invite your client to Kick? You can also invite them later.</p>

        <fields.Emails
            name="invite.emails"
            label="Email address"
            className={styles.emailField}
            placeholder="name@internetmoney.com, name@internetmoney.com,.."
        />

        <fields.Select
            name="invite.role"
            label="Role"
            className={styles.roleField}
            options={addClientInviteRoleOptions}
            placeholder="Select role"
            buttonProps={{ size: "xl" }}
        />
    </>
);
